module.exports = __webpack_public_path__ + "static/index-fee2e346edf0d1045f6485ebd848cbcf.pdf";